import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "toast-custom",
          title: "toast-title",
          description: "toast-description",
          success: "toast-success",
          error: "toast-error",
          warning: "toast-warning",
          info: "toast-info",
          icon: "toast-icon"
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
